import * as React from 'react'
import { css } from '@emotion/css'
import Typography from '@mui/material/Typography'
import theme from '@mike/mike-shared-frontend/mike-shared-styles/mikeSharedTheme'
import { useIntl } from 'react-intl'
import messages from '../../shared/messages'

const paddingStyle = css`
  padding: ${theme.spacing(1)};
`

/**
 * Shared "you don't have access to this page" fallback, used by the route
 * guards (`PrivateRoute`, `ProjectAccessGuard`). Keeps the copy and styling in
 * one place and internationalized.
 */
const NoPageAccess = () => {
  const intl = useIntl()
  return (
    <Typography className={paddingStyle} variant="h4" color="textPrimary">
      {intl.formatMessage(messages.noPageAccess)}
    </Typography>
  )
}

export default NoPageAccess
